import { useState } from "react";
import { useTranslation } from "react-i18next";
const useFindAndReplaceData = ({
  closeModal,
  columnConfig,
  columnIndex,
  getFindAndReplaceModalProps,
  onSubmit
}) => {
  const { label, value: fieldId, type, options } = columnConfig[columnIndex];
  const [isFetchingProps, setIsFetchingProps] = useState(false);
  const [replaceValue, setReplaceValue] = useState(
    ""
  );
  const [searchValue, setSearchValue] = useState("");
  const [exactMatchesOnly, setExactMatchesOnly] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorText, setErrorText] = useState(void 0);
  const [count, setCount] = useState(void 0);
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [ignoreFilter, setIgnoreFilter] = useState(false);
  const { t } = useTranslation();
  const handleOnSubmit = async (event) => {
    setIsSubmitting(true);
    event.preventDefault();
    try {
      const response = await onSubmit({
        searchValue,
        replaceValue,
        fieldId,
        exactMatchesOnly,
        ignoreFilter
      });
      if (response == null ? void 0 : response.error) {
        setErrorText(response == null ? void 0 : response.error);
        setIsSubmitting(false);
      } else {
        closeModal == null ? void 0 : closeModal();
        setIsSubmitting(false);
      }
    } catch (e) {
      setErrorText(
        t("sheet.table.contextMenu.findAndReplace.modal.errors.generalError")
      );
      setIsSubmitting(false);
    }
  };
  const handleOnSearch = async (searchValue2) => {
    setIsFetchingProps(true);
    setSearchValue(searchValue2);
    if (!getFindAndReplaceModalProps) {
      return setIsFetchingProps(false);
    }
    try {
      const { count: count2, error } = await getFindAndReplaceModalProps({
        searchValue: searchValue2,
        exactMatchesOnly,
        fieldId,
        ignoreFilter
      });
      if (error) {
        setErrorText(error);
      } else {
        setErrorText(void 0);
        setCount(count2);
      }
    } catch (e) {
      setErrorText(
        t("sheet.table.contextMenu.findAndReplace.modal.errors.generalError")
      );
    }
    setDisableSubmit(false);
    setIsFetchingProps(false);
  };
  const handleChange = (value) => {
    setReplaceValue(value);
  };
  const handleBooleanChange = (e) => {
    var _a;
    const value = (_a = e == null ? void 0 : e.target) == null ? void 0 : _a.value;
    if (value !== void 0 && value.length) {
      setReplaceValue(value === "true" ? true : false);
    }
  };
  const toggleExactMatchOnly = () => {
    setExactMatchesOnly(!exactMatchesOnly);
  };
  const toggleIgnoreFilter = () => {
    setIgnoreFilter(!ignoreFilter);
  };
  return {
    columnName: label ?? fieldId,
    count,
    handleBooleanChange,
    handleChange,
    handleOnSearch,
    handleOnSubmit,
    isFetchingProps,
    isSubmitting,
    replaceValue,
    type,
    options,
    errorText,
    disableSubmit,
    setDisableSubmit,
    exactMatchesOnly,
    toggleExactMatchOnly,
    ignoreFilter,
    toggleIgnoreFilter
  };
};
export {
  useFindAndReplaceData as default
};
